import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Importar archivos de traducción por página
import es404 from "./locales/pages/es/404.json";
import en404 from "./locales/pages/en/404.json";
import esCall from "./locales/pages/es/call.json";
import enCall from "./locales/pages/en/call.json";

const resources = {
  es: {
    "404": es404,
    call: esCall,
  },
  en: {
    "404": en404,
    call: enCall,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es", // Idioma por defecto
    debug: false, // Cambiar a true para desarrollo

    detection: {
      // Solo detectar idioma del navegador en la página 404
      // En otras páginas se usará assistantData.language
      order: ["navigator", "htmlTag"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },
  });

export default i18n;
